const state = {
    action: null
};

const mutations = {
    changeAction: (state, action) => { state.action = action }
}

const actions = {
    setAction: ({ commit }, action) => { commit('changeAction', action) }
}

const getters = {
    action: state => state.action
}

export const sidebar = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js